import { ButtonRenderProps, ButtonProps } from "sprint-common-web";

import { useFeatureFlags } from "../../../core/configuration/feature-flags/useFeatureFlags";
import { AddOrderButton } from "../create/AddOrderButton";
import { ClearSelectedOrdersButton } from "../dashboard/buttons/ClearSelectedOrdersButton";
import { RejectMultipleOrdersButton } from "../dashboard/reject/RejectMultipleOrdersButton";
import { DeleteMultipleOrdersButton } from "../delete/DeleteMultipleOrdersButton";
import { ExportOrdersButtonProps, ExportOrdersButton } from "../import/buttons/ExportOrdersButton";
import { ImportOrdersButton } from "../import/buttons/ImportOrdersButton";
import { PinOrderButton } from "./actions/PinOrderButton";
import { ApproveOrderDeliveriesButton } from "./approve-delivery/ApproveOrderDeliveriesButton";
import {
    SetOrderListingColumnsConfigButton,
    SetOrderListingColumnsConfigButtonProps
} from "./config/SetOrderListingColumnsConfigButton";
import { OrderListingFilters } from "./hooks/useOrderListingFilters";
import { MergeOrdersButton } from "./merge/MergeOrdersButton";

interface CreateOrderListingButtonsProps {
    filters: OrderListingFilters;
    setPageSize(pageSize: number): void;
}

type OrderListingButtons =
    | ButtonRenderProps<ButtonProps>
    | ButtonRenderProps<ExportOrdersButtonProps>
    | ButtonRenderProps<SetOrderListingColumnsConfigButtonProps>;

export const createOrderListingButtons = (props: CreateOrderListingButtonsProps): OrderListingButtons[] => {
    const { filters, setPageSize } = props;

    const addOrderButton: ButtonRenderProps<ButtonProps> = {
        render: AddOrderButton
    };

    const importOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: ImportOrdersButton
    };

    const exportOrdersButton: ButtonRenderProps<ExportOrdersButtonProps> = {
        render: ExportOrdersButton,
        filters: filters
    };

    const approveDeliveriesButton: ButtonRenderProps<ButtonProps> = {
        render: ApproveOrderDeliveriesButton
    };

    const mergeOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: MergeOrdersButton
    };

    const removeOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: DeleteMultipleOrdersButton
    };

    const rejectOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: RejectMultipleOrdersButton
    };

    const clearSelectedOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: ClearSelectedOrdersButton
    };

    const setOrderListingColumnsConfigButton: ButtonRenderProps<SetOrderListingColumnsConfigButtonProps> = {
        render: SetOrderListingColumnsConfigButton,
        pageSize: filters.pageSize,
        setPageSize
    };

    const pinOrdersButton: ButtonRenderProps<ButtonProps> = {
        render: PinOrderButton
    };

    return [
        addOrderButton,
        exportOrdersButton,
        importOrdersButton,
        approveDeliveriesButton,
        mergeOrdersButton,
        pinOrdersButton,
        removeOrdersButton,
        rejectOrdersButton,
        setOrderListingColumnsConfigButton,
        clearSelectedOrdersButton
    ].filter((item) => item !== null) as OrderListingButtons[];
};
